module.exports = __webpack_public_path__ + "static/media/icn-menu.d4b36ff3.svg";